export default {
    GetMembers: 'api/private/members',
    AddMember: 'api/private/members',
    DeleteMember: 'api/private/members',
    UpdateMember: 'api/private/members',
    GetMemberById: 'api/private/members',
  };
  